import { ERROR_MESSAGES } from 'utility/errors/errorMessages';

export const FALLBACK_ERROR_MESSAGE = ERROR_MESSAGES[500];

export const PLACEHOLDER_EXPORT = '';
